<div
  class="switch"
  [class.small]="small"
  [class.smallish]="smallish"
  [class.no-interaction]="noInteraction"
  appTransitionPreventor
>
  <ng-content></ng-content>
</div>
